import dayjs from 'dayjs';

export const pageLabels = { HOME: '首页', CATEGORY: '分类', PRODUCT: '商品详情', SEARCH: '搜索', PRICE_MONITOR: '价格监控', PROFILE: '我的', MEMBERSHIP: '会员', WALLET: '钱包', REBATE: '返利', INVITE: '邀请', MESSAGES: '消息', SETTINGS: '设置', PRIVACY: '隐私管理', HELP: '帮助', DISCOVERY: '发现', DEALS: '优惠专区', AI_GUIDE: 'AI 导购', LOGIN: '登录', OTHER: '其他' };
export const eventLabels = { PAGE_VIEW: '页面浏览', SEARCH: '主动搜索', BUY_LINK: '请求购买链接', PRICE_ALERT: '设置价格提醒', AI_GUIDE: '发起 AI 导购' };

export function dailySeries(report) {
  if (!report?.from || !report?.to) return [];
  const byDay = new Map((report.daily || []).map((row) => [dayjs(row.day).format('YYYY-MM-DD'), row]));
  const rows = [];
  for (let date = dayjs(report.from), i = 0; i < 30 && !date.isAfter(dayjs(report.to), 'day'); date = date.add(1, 'day'), i += 1) {
    const day = date.format('YYYY-MM-DD');
    const row = byDay.get(day) || {};
    rows.push({ day, loggedUsers: Number(row.loggedUsers || 0), anonymousInstalls: Number(row.anonymousInstalls || 0), foregroundEvents: Number(row.foregroundEvents || 0) });
  }
  return rows;
}
export function activityLines(report) {
  return dailySeries(report).flatMap((row) => [
    { day: row.day, series: '登录账号', value: row.loggedUsers },
    { day: row.day, series: '匿名安装', value: row.anonymousInstalls },
  ]);
}
export function retentionLines(report) {
  return (report?.retention || []).flatMap((row) => ['retained1', 'retained7'].flatMap((key) =>
    row[key] == null || !row.newSubjects ? [] : [{ day: dayjs(row.day).format('YYYY-MM-DD'), value: Number((100 * row[key] / row.newSubjects).toFixed(1)),
      series: `${row.kind === 'LOGGED' ? '账号' : '匿名'} · ${key === 'retained1' ? '次日' : '7日'}` }])).sort((a, b) => a.day.localeCompare(b.day));
}
export function featureBars(report) {
  return [...(report?.features || [])].sort((a, b) => Number(b.eventCount) - Number(a.eventCount)).slice(0, 10)
    .map((row) => ({ label: `${pageLabels[row.pageName] || row.pageName} · ${eventLabels[row.eventName] || row.eventName}`, value: Number(row.eventCount) }));
}
export function distributionBars(rows) {
  return (rows || []).slice(0, 12).flatMap((row) => [
    { label: row.label, series: '登录账号', value: Number(row.loggedUsers || 0) },
    { label: row.label, series: '匿名安装', value: Number(row.anonymousInstalls || 0) },
  ]);
}
